import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { assistantResources } from "./locales/assistant.js";
import { legalResources } from "./locales/legal.js";

// The platform is English only: no language detection and no other resources
i18n
	.use(initReactI18next)
// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		debug: false,
		lng: "en",
		fallbackLng: "en",
		supportedLngs: ["en"],
		// React already escapes rendered text; escaping here would double-escape values such as error reasons
		interpolation: { escapeValue: false },
		resources: { en: { translation: { assistant: assistantResources.en, legal: legalResources.en } } },
	});

// Screen readers pick their voice from the document language
document.documentElement.lang = "en";

export { default } from "i18next";
